import { render } from "./aio-login-datatable.vue?vue&type=template&id=80d3a44a"
import script from "./aio-login-datatable.vue?vue&type=script&lang=js"
export * from "./aio-login-datatable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__